module.exports = __webpack_public_path__ + "img/partner1.ff548b14.png";